import Chip from "@mui/material/Chip";

interface FilterChipProps {
  label: string;
  value: string;
  onRemove: () => void;
}

export default function FilterChip({ label, value, onRemove }: FilterChipProps) {
  return (
    <Chip
      label={`${label}: ${value}`}
      onDelete={onRemove}
      variant="outlined"
      size="small"
      sx={{
        borderRadius: "4px",
        fontSize: "12px",
        height: "28px",
      }}
    />
  );
}
